import { ActionIcon, Box, Button, type MantineBreakpoint, Menu, type PopoverWidth, type StyleProp, Text } from '@mantine/core';
import { type PropsWithChildren, useState } from 'react';
import classes from './SearchFillter.module.css';
import type { filter } from './data';
export type SearchFilterProps = PropsWithChildren & {
  label: string;
  w?: StyleProp<React.CSSProperties['width']>;
  filters: filter[];
  breakPoint: MantineBreakpoint;
  withArrow?: boolean;
  dropDownWidth?: PopoverWidth;
};
export const SearchFilter: React.FC<SearchFilterProps> = ({
  label,
  children,
  filters,
  w,
  breakPoint,
  withArrow,
  dropDownWidth
}) => {
  const [filterValue, setFilterValue] = useState(filters[0].value);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  return <Menu shadow="md" width={dropDownWidth ?? 150} withArrow={withArrow} menuItemTabIndex={0} classNames={classes} onOpen={() => setMenuIsOpen(true)} onClose={() => setMenuIsOpen(false)}>
      <Menu.Target>
        <Box>
          <Button visibleFrom={breakPoint} size="md" w={w} h={46} radius="sm" tt="uppercase" fz="xs" px={0} bg="var(--navbar-bg-color)" leftSection={<Box c={menuIsOpen ? 'var(--text-prime)' : 'var(--icon-primary)'}>
                {children}
              </Box>} rightSection={<Text maw={60} truncate="end" span inherit tt="capitalize" c="var(--text-dark)">
                {filterValue}
              </Text>}>
            <Text inherit c="var(--text-dark)">
              {label}
            </Text>
          </Button>

          <ActionIcon hiddenFrom={breakPoint} w={46} h={46} radius={5} bg="var(--striped-bg-color)" c={menuIsOpen ? 'var(--text-prime)' : 'var(--icon-primary)'}>
            {children}
          </ActionIcon>
        </Box>
      </Menu.Target>

      <Menu.Dropdown bg="var(--striped-bg-color)">
        {filters.map(filter => <Menu.Item tt="capitalize" p={10} key={filter.key} onClick={() => setFilterValue(filter.value)} fz="xs">
            {filter.value}
          </Menu.Item>)}
      </Menu.Dropdown>
    </Menu>;
};